
import { Options, Vue } from 'vue-class-component'
import PORTFOLIO from '@/data/portfolio'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import Card from 'primevue/card'
import Tag from 'primevue/tag'

@Options({
  components: {
    Button,
    Dialog,
    Card,
    Tag,
  },
})
export default class Portfolio extends Vue {
  dialogIsOpened = false
  length = 200
  dialog = {}
  defaultDialog = {
    src: '',
    title: '',
    subtitle: '',
    text: '',
    tags: [],
  }

  getText(text: string): string {
    if (!this.isLotOfDescription(text)) {
      return text
    }

    const cutText = text.slice(0, this.length)
    const arrText = cutText.split(' ')

    arrText.splice(arrText.length - 1, 1)

    return arrText.join(' ') + '...'
  }

  openDialog(item: any): void {
    if (!this.isLotOfDescription(item.text)) {
      return
    }

    this.dialogIsOpened = true
    this.dialog = { ...item }
  }

  closeMaximizable() {
    this.dialogIsOpened = false
    this.dialog = { ...this.defaultDialog }
  }

  isLotOfDescription(text: string): boolean {
    return text.length > this.length
  }

  get list() {
    return PORTFOLIO
  }
}
